import { render, staticRenderFns } from "./addOnTrialItem.vue?vue&type=template&id=3e88b1aa&scoped=true&"
import script from "./addOnTrialItem.vue?vue&type=script&lang=js&"
export * from "./addOnTrialItem.vue?vue&type=script&lang=js&"
import style0 from "./addOnTrialItem.vue?vue&type=style&index=0&id=3e88b1aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e88b1aa",
  null
  
)

export default component.exports